import { fromZonedTime, toZonedTime } from 'date-fns-tz';

/** Get date object for a specific timezone from form inputs  */
export function formDateToISO(date: Date, time: string, timezone: string): string {
  if (!date || !time || !timezone) { throw new Error('Date, time, and timezone are required'); }
  // Get hours and minutes from time
  const [hours, minutes] = time.split(':').map(Number);
  // Set hours and minutes to date
  date.setHours(hours, minutes);
  // Convert date to timezone
  return fromZonedTime(date, timezone).toISOString();
}

/**
 * Get zoned date from ISO.
 *
 * Changes the time, but doesn't override the UTC offset in the date object.
 * Do NOT call .toIsoString() */
export function isoToDisplayDate(iso: string, timezone: string): Date {
  if (!iso || !timezone) { throw new Error('ISO and timezone are required'); }
  return toZonedTime(iso, timezone);
}
